
export default class Env {
    public static officeEmail = 'biuro@szklo-hartowane.pl'
    public static smtpUsername = 'i.sowinski@szklo-hartowane.pl'
    public static smtpPassword = 'K8pNnLh15qOQMAgm'
}